import SelectItem from '@/common/interfaces/SelectItem';
import ApiService from '@/common/ApiService/ApiService';
import { HttpVerb } from '@/common/ApiService/HttpVerb';
import { SecondStepModel } from '@/modules/DerSignUpModule/SecondStep/SecondStep.types';

const DerService = new ApiService('/api/DerService/', {
  showLoading: false,
  cancel: true,
  returnData: true,
});

const DerSignupApiService = new ApiService('/api/DerSignupApiService/', {
  showLoading: false,
  cancel: true,
  returnData: true,
});

export const GetItineraries = async (
  destinationId: number,
  showLoading: boolean,
): Promise<SelectItem[]> => {
  return new Promise(async (resolve) => {
    const itineraries = await DerService.call(
      `GetActiveItineraries?destId=${destinationId}`,
      {},
      {
        showLoading,
        verb: HttpVerb.GET,
      },
    );
    resolve(itineraries);
  });
};

export const GetDates = async (
  itineraryId: number,
  showLoading: boolean,
): Promise<SelectItem[]> => {
  return new Promise(async (resolve) => {
    const dates = await DerService.call(
      `GetDeparturesWithInProgress?itineraryId=${itineraryId}`,
      {},
      {
        showLoading,
        verb: HttpVerb.GET,
      },
    );
    resolve(dates);
  });
};

export const SendSignUpRequest = async (
  data: SecondStepModel,
  showLoading: boolean,
): Promise<any> => {
  return new Promise(async (resolve) => {
    const dates = await DerService.call(`SendDERSignUpRequest`, data, {
      showLoading,
      verb: HttpVerb.POST,
    });
    resolve(dates);
  });
};

export const GetShipIntro = async (
  departureId: string,
  showLoading: boolean,
): Promise<SelectItem[]> => {
  return new Promise(async (resolve) => {
    const shipInfo = await DerSignupApiService.call(
      `GetShipIntro?departureId=${departureId}`,
      {}, 
      {
        showLoading,
        verb: HttpVerb.GET
      });
    resolve(shipInfo);
  });
};

export const GetPastDers = async (
  departureId: string,
  destinationId: string,
  showLoading: boolean,
): Promise<SelectItem[]> => {
  return new Promise(async (resolve) => {
    const pastDers = await DerSignupApiService.call(
      `GetPastDers?departureId=${departureId}&destinationId=${destinationId}`,
      {}, 
      {
        showLoading,
        verb: HttpVerb.GET
      });
    resolve(pastDers);
  });
};
